import store from '@/store';
import { AddressValidationQuotaResponse } from '@/modules/Client/Interfaces/AddressValidation';
import Client from '@/models/Client';

export function updateValidationRequestsRemaining(data?: AddressValidationQuotaResponse | null) {
    const quota = data?.quota;

    if (
        quota &&
        [quota.limit, quota.used, quota.remaining].every(
            (value) => typeof value === 'number' && Number.isFinite(value) && value >= 0,
        )
    ) {
        return store.dispatch('generic/updateValidationRequestsRemaining', quota);
    }
}

export async function getValidationQuota() {
    try {
        const validationResult = (await Client.getValidationQuota()) as any;
        updateValidationRequestsRemaining(validationResult?.data);
    } catch (error) {
        console.error('Failed to fetch validation quota:', error);
    }
}
